import { useContext } from 'react'
import logAnalyticsEvent from '../../utilities/firebase-analytics'
import { LoginContext } from '../../contexts/login-context'
import { ApiContext } from '../../contexts/api-context'
import ReportingFilter from '../../components/reporting/filters/reporting-filter'
import { ReportPageContainer, PageTitle } from '../report-page/report-page-styles'
import { GlobalStyle } from '../../styles/global-styles'
import { ReportingProvider } from '../../contexts/reporting-context'
import ReportingCard from '../../components/reporting/cards/reporting-card'
import ReportingCharts from '../../components/reporting/charts/reporting-charts'

const ReportPage = () => {
  const { user } = useContext(LoginContext)
  const { userProfile } = useContext(ApiContext)

  logAnalyticsEvent('page_view', {
    page_location: '/report',
    page_title: 'Report',
    user: user?.email,
    team: userProfile?.team
  })

  return (
    <ReportingProvider>
      <GlobalStyle page="report" />
      <ReportPageContainer>
        <PageTitle>Reporting Dashboard</PageTitle>
      </ReportPageContainer>
      <ReportingFilter></ReportingFilter>
      <ReportingCard></ReportingCard>
      <ReportingCharts></ReportingCharts>
    </ReportingProvider>
  )
}

export default ReportPage
